import { component } from 'picoapp';

export default component(async (node) => {
  const initCountry = () => {
    const { stores } = window.theme;
    const thisStore = stores.find((store) => store.shopifyUrl === window.Shopify.shop);

    node.innerHTML = `<div class="flag-icon absolute top-1/2 left-0 transform -translate-y-1/2">${thisStore.flagIcon}</div>
    <p class="text-lg font-light">${thisStore.name}</p>`;
  };

  const init = () => {
    initCountry();
  };

  init();
});
